import { useState, useEffect } from "react";
import { Grid, TextField, Backdrop, CircularProgress, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, InputLabel, OutlinedInput, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, useMediaQuery, useTheme, Card, CardContent, Typography, Chip } from "@mui/material";

import axios from "../api/axios"
import InversionistaFind2 from "./InversionistaFind2";

export default function DepositosFind(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [openDialog, setOpenDialog] = useState(false)
    const [rows, setRows] = useState([]);
    const [seleccion, setSeleccion] = useState(0)
    const [procesando, setProcesando] = useState(false)

    const [inversionista, setInversionista] = useState({ id: 0, label: '' });
    const [inversionistaInput, setInversionistaInput] = useState("")
    const [desde, setDesde] = useState("")
    const [hasta, setHasta] = useState("")

    useEffect(() => {
        setDesde(getDesde())
        setHasta(getHasta())
    }, [])

    useEffect(() => {
        setOpenDialog(props.open)
    }, [props.open]);

    useEffect(() => {
        actRows();
    }, [inversionista, desde, hasta])


    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;

        var yyyy = cual.getFullYear();
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = yyyy + '-' + mm + '-01';
        return today;
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();

        if (mm==12){
            mm = 1
            yyyy++;
        } else {
            mm++;
        }

        let prox = new Date(yyyy, (mm-1), 1);
        prox.setDate(prox.getDate()-1)

        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();
        
        if (mm < 10) {
            mm = '0' + mm;
        }
        if (dd < 10) {
            dd = '0' + dd;
        }

        var today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const actRows = async () => {
        setProcesando(true)
        let mRows = []
        try {
            const respuesta = await axios.post("movimientos/buscar", {
                inversionista: inversionista.id,
                desde: desde,
                hasta: hasta
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data.lista;
            console.log(data)
            if (data){
                data.map((item) => {
                    let mId = item.id;
                    let mNombre = item.nombre;
                    let mMonto = item.monto;
                    let mFecha = item.fecha
                    mRows.push({
                        id: mId,
                        nombre: mNombre,
                        monto: mMonto,
                        fecha: mFecha
                    })
                })
            }

        } catch (error) {
            console.log(error)
        }
        setRows(mRows)
        setProcesando(false)
    }

    const handleSeleccion = (cual) => {
        setSeleccion(cual)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    const handleCambioInversionista = (value) => {
        setInversionista(value)
    }
    const handleCambioInversionistaInput = (value) => {
        setInversionistaInput(value)
    }

    // Calcular total de montos
    const totalMonto = rows.reduce((acc, row) => acc + parseFloat(row.monto || 0), 0);

    // Renderizar tarjetas para vista móvil
    const renderMobileCards = () => {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pb: 2 }}>
                {rows.map((item) => {
                    const monto = parseFloat(item.monto || 0);
                    const isSelected = item.id === seleccion;

                    return (
                        <Card
                            key={item.id}
                            onClick={() => handleSeleccion(item.id)}
                            onDoubleClick={() => props.seleccion(item.id)}
                            sx={{
                                border: isSelected ? '2px solid #d4af37' : '1px solid rgba(30, 58, 95, 0.1)',
                                borderRadius: 2,
                                boxShadow: isSelected ? '0 4px 12px rgba(212, 175, 55, 0.3)' : '0 2px 8px rgba(30, 58, 95, 0.08)',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                backgroundColor: isSelected ? 'rgba(212, 175, 55, 0.05)' : 'white'
                            }}
                        >
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.85rem' }}>
                                            {item.nombre}
                                        </Typography>
                                        <Typography sx={{ color: '#718096', fontSize: '0.7rem', mt: 0.5 }}>
                                            {item.fecha}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'right' }}>
                                        <Typography sx={{
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                            color: '#d4af37'
                                        }}>
                                            {monto.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>
        );
    };

    return (
        <Dialog
            maxWidth={"600px"}
            open={openDialog}
            fullWidth
            fullScreen={isMobile}
            PaperProps={{
                sx: isMobile ? {
                    margin: 0,
                    maxHeight: '100%',
                    borderRadius: 0
                } : {}
            }}
        >
            {objWait()}
            <DialogTitle sx={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                color: 'white',
                fontWeight: 600,
                textAlign: 'center',
                py: isMobile ? 1.5 : 2,
                fontSize: isMobile ? '1rem' : '1.25rem'
            }}>
                Búsqueda de Depósitos
            </DialogTitle>
            <DialogContent sx={{
                p: isMobile ? 1.5 : 2,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
            }}>
                {/* Filtros */}
                <Box sx={{ mb: isMobile ? 1.5 : 2 }}>
                    <Grid container spacing={isMobile ? 1 : 2}>
                        <Grid item xs={12}>
                            <InversionistaFind2
                                value={inversionista}
                                inputValue={inversionistaInput}
                                handleCambio={handleCambioInversionista}
                                handleCambioInput={(value) => { setInversionistaInput(value) }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: isMobile ? '0.85rem' : '1rem' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size={isMobile ? 'small' : 'medium'}
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: isMobile ? '0.85rem' : '1rem' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>

                {/* Resumen con chips */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1.5,
                    gap: 1
                }}>
                    <Chip
                        label={`${rows.length} depósitos`}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(30, 58, 95, 0.1)',
                            color: '#1e3a5f',
                            fontWeight: 600,
                            fontSize: '0.7rem'
                        }}
                    />
                    <Chip
                        label={`Total: ${totalMonto.toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(212, 175, 55, 0.2)',
                            color: '#d4af37',
                            fontWeight: 600,
                            fontSize: '0.7rem'
                        }}
                    />
                </Box>

                {/* Lista de depósitos */}
                {isMobile ? (
                    <Box sx={{
                        flex: 1,
                        overflow: 'auto',
                        WebkitOverflowScrolling: 'touch'
                    }}>
                        {renderMobileCards()}
                    </Box>
                ) : (
                    <TableContainer component={Paper} sx={{ height: "400px", flex: 1 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)', color: 'white', fontWeight: 600 }}>Nombre</TableCell>
                                    <TableCell sx={{ background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)', color: 'white', fontWeight: 600 }}>Fecha</TableCell>
                                    <TableCell sx={{ background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)', color: 'white', fontWeight: 600, textAlign: 'right' }}>Monto</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((item, index) => (
                                    <TableRow
                                        key={item.id}
                                        hover
                                        onClick={() => { handleSeleccion(item.id) }}
                                        selected={item.id == seleccion}
                                        onDoubleClick={() => props.seleccion(item.id)}
                                        sx={{
                                            '&:hover': { backgroundColor: 'rgba(44, 82, 130, 0.04)' },
                                            '&.Mui-selected': { backgroundColor: 'rgba(212, 175, 55, 0.1)' },
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <TableCell sx={{ color: '#1e3a5f' }}>{item.nombre}</TableCell>
                                        <TableCell sx={{ color: '#1e3a5f' }}>{item.fecha}</TableCell>
                                        <TableCell sx={{ textAlign: 'right', color: '#d4af37', fontWeight: 500 }}>
                                            {parseFloat(item.monto || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions sx={{
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? 1 : 1,
                p: isMobile ? 2 : 1,
                borderTop: '1px solid rgba(30, 58, 95, 0.1)'
            }}>
                <Button
                    onClick={() => { props.cerrar() }}
                    variant="outlined"
                    fullWidth={isMobile}
                    sx={{
                        order: isMobile ? 2 : 1,
                        color: '#1e3a5f',
                        borderColor: '#1e3a5f',
                        py: isMobile ? 1.5 : 1
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={() => { props.seleccion(seleccion) }}
                    variant="contained"
                    fullWidth={isMobile}
                    disabled={seleccion === 0}
                    sx={{
                        order: isMobile ? 1 : 2,
                        background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                        py: isMobile ? 1.5 : 1,
                        '&:hover': {
                            background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                        },
                        '&.Mui-disabled': {
                            background: 'rgba(0, 0, 0, 0.12)'
                        }
                    }}
                >
                    Seleccionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}